module.exports = __webpack_public_path__ + "static/media/8101.25dcee35.jpg";